import React, { lazy } from 'react';
const MEGAPACK_IMAGE = 'https://cdn.magicpatterns.com/uploads/pbrCeuDQ19uqW6QFTXChxA/tango_png.png';
interface MegapackImageProps {
  size?: 'large' | 'small';
  className?: string;
  onClick?: () => void;
}
export function MegapackImage({
  size = 'large',
  className = '',
  onClick
}: MegapackImageProps) {
  const isLarge = size === 'large';
  const maxWidth = isLarge ? 'max-w-3xl' : 'max-w-md';
  return <div className={`w-full ${maxWidth} mx-auto ${onClick ? 'cursor-pointer' : ''} ${className}`} onClick={onClick} data-id="element-111">
      <img src={MEGAPACK_IMAGE} alt="TangoPack - Il Sistema Completo per Insegnanti di Tango" className="w-full h-auto" loading="lazy" data-id="element-112" />
    </div>;
}